import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberProjectDetailPage from "@/pages/member/MemberProjectDetailPage";

export const Route = createFileRoute("/member/projects/$id")({
  head: ({ params }) => pageHead("Project Opportunity | AKIVA Network", "Review an AKIVA Network opportunity, project goals and skill requirements before expressing interest.", `/member/projects/${params.id}`, true),
  component: MemberProjectDetailPage,
});
